import DashboardIncidentOpenIncidentsBreakdownCard from './DashboardIncidentOpenIncidentsBreakdownCard';

export default DashboardIncidentOpenIncidentsBreakdownCard;
